export default __webpack_public_path__ + "static/media/contactPic.40c276bb.jpg";